/** Browser storage keys scoped per shop: `{slug}_suffix` */
export function shopStorageKey(slug: string, suffix: string): string {
  const normalized = slug.trim().toLowerCase()
  return normalized ? `${normalized}_${suffix}` : suffix
}

const LEGACY_PREFIX = 'cdt_'

function migrateLegacyLocalValue(
  slug: string,
  suffix: string,
  legacyKey: string,
  storage: Storage,
): string | null {
  const key = shopStorageKey(slug, suffix)
  const direct = storage.getItem(key)
  if (direct != null) return direct

  const legacyShopKey = slug
    ? `${LEGACY_PREFIX}${slug.trim().toLowerCase()}_${suffix}`
    : `${LEGACY_PREFIX}${suffix}`
  const legacyShop = storage.getItem(legacyShopKey)
  if (legacyShop != null) {
    storage.setItem(key, legacyShop)
    storage.removeItem(legacyShopKey)
    return legacyShop
  }

  const legacyGlobal = legacyKey ? storage.getItem(legacyKey) : null
  if (legacyGlobal != null && slug) {
    storage.setItem(key, legacyGlobal)
    storage.removeItem(legacyKey)
    return legacyGlobal
  }

  return null
}

export function readShopStorage(slug: string, suffix: string, legacyGlobalKey?: string): string | null {
  if (!import.meta.client) return null
  if (legacyGlobalKey) {
    return migrateLegacyLocalValue(slug, suffix, legacyGlobalKey, localStorage)
  }

  const key = shopStorageKey(slug, suffix)
  const direct = localStorage.getItem(key)
  if (direct != null) return direct

  const legacyKey = slug
    ? `${LEGACY_PREFIX}${slug.trim().toLowerCase()}_${suffix}`
    : `${LEGACY_PREFIX}${suffix}`
  const legacy = localStorage.getItem(legacyKey)
  if (legacy != null) {
    localStorage.setItem(key, legacy)
    localStorage.removeItem(legacyKey)
    return legacy
  }
  return null
}

export function writeShopStorage(slug: string, suffix: string, value: string, legacyGlobalKey?: string): void {
  if (!import.meta.client) return
  localStorage.setItem(shopStorageKey(slug, suffix), value)
  if (legacyGlobalKey) {
    localStorage.removeItem(legacyGlobalKey)
  }
}

export function removeShopStorage(slug: string, suffix: string, legacyGlobalKey?: string): void {
  if (!import.meta.client) return
  const normalized = slug.trim().toLowerCase()
  localStorage.removeItem(shopStorageKey(normalized, suffix))
  localStorage.removeItem(normalized ? `${LEGACY_PREFIX}${normalized}_${suffix}` : `${LEGACY_PREFIX}${suffix}`)
  if (legacyGlobalKey) {
    localStorage.removeItem(legacyGlobalKey)
  }
}

export function readShopSessionStorage(slug: string, suffix: string, legacyGlobalKey?: string): string | null {
  if (!import.meta.client) return null
  if (!legacyGlobalKey) {
    return sessionStorage.getItem(shopStorageKey(slug, suffix))
  }
  return migrateLegacyLocalValue(slug, suffix, legacyGlobalKey, sessionStorage)
}

export function writeShopSessionStorage(slug: string, suffix: string, value: string, legacyGlobalKey?: string): void {
  if (!import.meta.client) return
  sessionStorage.setItem(shopStorageKey(slug, suffix), value)
  if (legacyGlobalKey) {
    sessionStorage.removeItem(legacyGlobalKey)
  }
}

export function removeShopSessionStorage(slug: string, suffix: string, legacyGlobalKey?: string): void {
  if (!import.meta.client) return
  const normalized = slug.trim().toLowerCase()
  sessionStorage.removeItem(shopStorageKey(normalized, suffix))
  sessionStorage.removeItem(normalized ? `${LEGACY_PREFIX}${normalized}_${suffix}` : `${LEGACY_PREFIX}${suffix}`)
  if (legacyGlobalKey) {
    sessionStorage.removeItem(legacyGlobalKey)
  }
}
